"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const seam_types_1 = require("./seam.types");
const initialState = {
    isLoading: true,
    isError: false,
    isFailed: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataArea: [],
    dataBrand: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        seam: '',
        is_active: {
            value: true,
            status: 'Active',
        },
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date(),
        id_area: '',
        area_name: '',
        area: {
            id: '',
            area_name: '',
        },
        id_brand: '',
        brand_name: '',
        brand: {
            id: '',
            name: '',
        }
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const seamReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [seam_types_1.seamTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [seam_types_1.seamTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [seam_types_1.seamTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isFailed } = action.payload;
        return Object.assign(Object.assign({}, state), { isFailed, dataItem: dataItem ? dataItem : initialState.dataItem, mutationMode: mutationMode });
    },
    [seam_types_1.seamTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, mutationMode, isFailed, messageError } = action.payload;
        return Object.assign(Object.assign({}, state), { messageError,
            isFailed,
            dataItem,
            mutationMode, isLoading: true, dataGrid: state.dataGrid.map(item => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    },
    [seam_types_1.seamTypes.ON_DELETE]: (state) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, mutationMode: false });
    },
    [seam_types_1.seamTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [seam_types_1.seamTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    },
    [seam_types_1.seamTypes.SET_ERROR]: (state, action) => {
        const { isError, errorCode, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError, errorCode, errorMessage, isLoading: false });
    },
    [seam_types_1.seamTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    },
    [seam_types_1.seamTypes.GET_DETAIL]: (state, action) => {
        const { dataArea, dataBrand } = action.payload;
        return Object.assign(Object.assign({}, state), { dataArea,
            dataBrand });
    },
});
exports.default = seamReducer;
